<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!(_array.isArray(janelas)) || !(janelas.length)">
        Não foram encontradas janelas com os filtros informados.
    </div>
    <div class="table-responsive" *ngIf=" (_array.isArray(janelas) && (janelas.length))">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th id="col-data-envio" scope="col">Id</th>
                    <th id="col-data-envio" scope="col">Cesta</th>
                    <th id="col-data-envio" scope="col">Data Início Janela </th>
                    <th id="col-data-envio" scope="col">Data Fim da Janela</th>
                    <th id="col-data-envio" scope="col">Data Última Execução</th>
                    <th id="col-data-envio" scope="col">Data Fim Execução</th>
                    <th id="col-data-envio" scope="col">Fechamento Realizado</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let janela of janelas" id="pointer" [routerLink]="['/janelas-apuracao/', janela.id]">
                    <td>{{janela.id}}</td>
                    <td>{{ recuperarNumeroTranche(janela.ideTranche) }}</td>
                    <td>{{janela.dataInicioJanela | date: 'dd/MM/yyyy'}}</td>
                    <td>{{janela.dataFimJanela | date: 'dd/MM/yyyy'}}</td>
                    <td>{{janela.dataUltimaExecucao | date: 'dd/MM/yyyy'}}</td>
                    <td>{{janela.dataFimExecucao | date: 'dd/MM/yyyy'}}</td>
                    <td>{{janela.fechamentoRealizado === true ? 'Sim' : 'Não'}}</td>

                </tr>
            </tbody>
        </table>
    </div>
</div>